export function pdf_text_stream(lines = []) {
  return lines
    .map((line) => line.type === 'rect' ? pdf_rect(line) : pdf_text(line))
    .join('\n');
}

function pdf_text(line = {}) {
  const position = pdf_position(line);
  return [
    pdf_text_color(line),
    `BT /F1 ${pdf_font_size(line)} Tf`,
    `${position} Td`,
    `(${pdf_escape(line.text)}) Tj ET`,
  ].join(' ');
}

function pdf_position(line = {}) {
  return `${pdf_x(line)} ${pdf_y(line)}`;
}

function pdf_text_color(line = {}) {
  return line.color === 'white' ? '1 1 1 rg' : '0 0 0 rg';
}

function pdf_font_size(line = {}) {
  return line.size || 9;
}

function pdf_x(line = {}) {
  return line.x || 40;
}

function pdf_y(line = {}) {
  return line.y || 720;
}

function pdf_rect(line = {}) {
  const color = pdf_rgb(line.color || '12 81 68');
  return `${color} rg ${line.x} ${line.y} ${line.width} ${line.height} re f`;
}

export function pdf_document(objects = []) {
  const parts = ['%PDF-1.4\n'];
  const offsets = [];
  objects.forEach((object, index) => {
    offsets.push(parts.join('').length);
    parts.push(`${index + 1} 0 obj\n${object}\nendobj\n`);
  });
  add_xref(parts, offsets, objects.length);
  return parts.join('');
}

function add_xref(parts, offsets = [], object_count = 0) {
  const xref_offset = parts.join('').length;
  parts.push(`xref\n0 ${object_count + 1}\n0000000000 65535 f \n`);
  offsets.forEach((offset) => {
    parts.push(`${String(offset).padStart(10, '0')} 00000 n \n`);
  });
  parts.push(`trailer << /Size ${object_count + 1} /Root 1 0 R >>\nstartxref\n${xref_offset}\n%%EOF`);
}

function pdf_escape(value = '') {
  return normalize_pdf_text(value).replace(/[\\()]/g, '\\$&').slice(0, 130);
}

function normalize_pdf_text(value = '') {
  return String(value ?? '')
    .replace(/[\u2013\u2014]/g, '-')
    .replace(/[\u2018\u2019]/g, "'")
    .replace(/[\u201c\u201d]/g, '"')
    .replace(/[^\x20-\x7E]/g, '');
}

function pdf_rgb(value = '') {
  return value
    .split(/\s+/)
    .map((channel) => Number(channel) / 255)
    .map((channel) => Number.isFinite(channel) ? channel.toFixed(3) : '0')
    .join(' ');
}
